// Envoie les inscriptions "etre informe du lancement" vers Brevo (via le service
// Hexagon, voir hexagon-communaute /api/inscription). S'ajoute a la soumission
// native Shopify sans la modifier : aucun preventDefault, un echec ici ne bloque jamais l'envoi.
// Formulaires : footer (Footer), bloc HP (Home Page), configurateur (Configurateur,
// avec la configuration en cours fournie par window.HexagonBrevoConfig()).
(function () {
  // Phase du site (opening / pre_order / live) : choisit la liste Brevo cote service.
  var PHASE = (document.currentScript && document.currentScript.getAttribute('data-phase')) || 'live';
  var ENDPOINT = 'https://hexagon-communaute.vercel.app/api/inscription';
  var FORMS = {
    FooterNewsletter: 'Footer',
    HomeEmailInterestForm: 'Home Page',
    ConfiguratorNotifyForm: 'Configurateur'
  };

  document.addEventListener('submit', function (event) {
    try {
      var form = event.target;
      var formulaire = form && FORMS[form.id];
      if (!formulaire) return;
      var field = form.querySelector('input[type="email"]');
      var email = field && field.value.trim();
      if (!email) return;
      var payload = { email: email, formulaire: formulaire, phase: PHASE };
      if (formulaire === 'Configurateur' && typeof window.HexagonBrevoConfig === 'function') {
        try { payload.config = window.HexagonBrevoConfig(); } catch (configErr) { /* inscription sans configuration */ }
      }
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true
      }).catch(function () { /* silencieux : la soumission Shopify suit son cours */ });
    } catch (err) { /* ne jamais bloquer l'envoi */ }
  }, true);
})();
